export default __webpack_public_path__ + "static/media/two.69100f83.jpg";